// @flow
import * as React from 'react'
import styled from 'styled-components'
import FlatCard from 'ui/atoms/FlatCard'
import Text from 'ui/atoms/Text'
import Theme from 'ui/theme'

type Props = {
  $active?: boolean,
  children: React.Node,
  error?: ?string,
}

const StyledSelectableFlatCard: React.ComponentType<Props> = styled(FlatCard)`
  cursor: pointer;

  ${({ $active }: Props) =>
    $active
      ? `
    background: ${Theme.color.main}!important;
    border-color: ${Theme.color.borderPrimary};
  `
      : `
    &:hover {
      background: ${Theme.color.mainHover}!important;
    }
  `}

  ${({ error }: Props) =>
    error &&
    `
    border-color: ${Theme.color.error};
  `}
`

function SelectableFlatCard({ children, error, ...props }: Props): React.Node {
  return (
    <>
      <StyledSelectableFlatCard {...props} error={error}>
        {children}
        {error && (
          <Text $red $small>
            {error}
          </Text>
        )}
      </StyledSelectableFlatCard>
    </>
  )
}

export default SelectableFlatCard
